@if (form(); as form) {
  <ng-container [formGroup]="form">
    <fieldset>
      <legend>
        Kategoria zgłoszenia
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"reportCategory" as controlName'>
            <label [for]='controlName'>
              Kategoria *
            </label>
            <select
              (change)="form.reportCategoryChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option [value]="null">Wybierz</option>
              @for (item of form.reportCategories; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    @if (form.geometry) {
      <fieldset>
        <legend>
          Lokalizacja
        </legend>
        <div class='row'>
          <div class='col-12'>
            <div>
              Punkt *:&nbsp;
              <button
                *ngIf='!showDrawTerrain && !form.geometry.value?.length'
                type='button'
                class='btn btn-secondary'
                (click)='showDrawTerrain = true'>
                <i class='fa fa-map' aria-hidden='true'></i>
                <span aria-hidden='true'>Dodaj</span>
                <span class='sr-only'>Dodaj geometrie</span>
              </button>
              <button
                *ngIf='!showDrawTerrain && !!form.geometry.value?.length'
                type='button'
                class='btn btn-secondary'
                (click)='showDrawTerrain = true'>
                <i class='fa fa-map-marked' aria-hidden='true'></i>
                <span aria-hidden='true'>Edytuj</span>
                <span class='sr-only'>Edytuj geometrie</span>
              </button>
              @if (form.geometry.invalid && form.geometry.touched) {
                <span class='d-inline-block ms-3 mt-3'>
                  <app-alert type='danger' [closable]='false'>Pole jest wymagane</app-alert>
                </span>
              }
            </div>
            @if (showDrawTerrain) {
              <br>
              <div>
                <app-draw-and-modify-terrain
                  [createImage]="true"
                  (mapImage)="form.mapImage?.setValue($event)"
                  drawType="Point"
                  (apply)='showDrawTerrain = false'
                  (cancel)='onCancelDraw()'
                  [formControl]='form.geometry'>
                </app-draw-and-modify-terrain>
              </div>
            }
          </div>
        </div>
        <br>
      </fieldset>
    }
    <fieldset>
      <legend>
        Opis zgłoszenia
      </legend>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"notes" as controlName'>
            <label [for]='controlName'>
              Opis @if (form.get(controlName)?.hasValidator(Validators.required)) {
              *
            }
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu zgłoszenie'>
            </textarea>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend class="mb-3">
        Dane zgłaszającego
      </legend>
      <div class="row">
        <div class="col-12">
          <app-alert [closable]="false" type="info">
            Gdy przeanalizujemy zgłoszenie, poinformujemy Cię o tym w wiadomości wysłanej na podany adres e-mail.
          </app-alert>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"firstName" as controlName'>
            <label [for]='controlName'>
              Imię/Imiona *
            </label>
            <input
              [readonly]="authed"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu imię/imiona'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"lastName" as controlName'>
            <label [for]='controlName'>
              Nazwisko *
            </label>
            <input
              [readonly]="authed"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwisko'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"phone" as controlName'>
            <label [for]='controlName'>
              Numer telefonu
            </label>
            <input
              mask='0*'
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu numer telefonu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"email" as controlName'>
            <label [for]='controlName'>
              E-mail *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu e-mail'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    @if (form.photo1 && form.photo2 && form.photo3) {
      <fieldset>
        <legend>
          Zdjęcia
        </legend>
        <br>
        <div class="row">
          <div class="col-12">
            <ol>
              @if (form.photo1; as control) {
                <li>
                  <div class='row'>
                    <div class='col-md-7'>
                      <p>
                        @if (control?.hasValidator(Validators.required)) {
                          *
                        } Zdjęcie 1
                      </p>
                    </div>
                    <div class='col-md-5'>
                      <app-file-uploader tagName='photo1' [formControl]='control' [multiple]="false">
                      </app-file-uploader>
                    </div>
                  </div>
                </li>
                <br>
              }
              @if (form.photo2; as control) {
                <li>
                  <div class='row'>
                    <div class='col-md-7'>
                      <p>
                        @if (control?.hasValidator(Validators.required)) {
                          *
                        } Zdjęcie 2
                      </p>
                    </div>
                    <div class='col-md-5'>
                      <app-file-uploader tagName='photo2' [formControl]='control' [multiple]="false">
                      </app-file-uploader>
                    </div>
                  </div>
                </li>
                <br>
              }
              @if (form.photo3; as control) {
                <li>
                  <div class='row'>
                    <div class='col-md-7'>
                      <p>
                        @if (control?.hasValidator(Validators.required)) {
                          *
                        } Zdjęcie 3
                      </p>
                    </div>
                    <div class='col-md-5'>
                      <app-file-uploader tagName='photo3' [formControl]='control' [multiple]="false">
                      </app-file-uploader>
                    </div>
                  </div>
                </li>
              }
            </ol>
          </div>
        </div>
      </fieldset>
      <br>
    }
    <fieldset>
      <legend>
        Zapoznaj się z regulaminem oraz klauzulą.
      </legend>
      <br>
      <app-accordion-group>
        <app-accordion-item [expanded]='false' name='Regulamin'>
          <ng-container *ngIf='subpages() | subpageContentByUrl: "regulamin" as subpage'>
            <div [innerHTML]='subpage?.content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"regulations" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z regulaminem e-usługi
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
      <app-accordion-group>
        <app-accordion-item [expanded]='false' name='Klauzula RODO'>
          <ng-container *ngIf='subpages() | subpageContentByUrl: "rodo" as subpage'>
            <div [innerHTML]='subpage?.content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"clause" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z klauzulą informacyjną RODO
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </fieldset>
  </ng-container>
}
